<template>
  <Card class="mb-5">
    <div
      @click="selectTeam(object.idTeam)"
      class="flex justify-between cursor-pointer"
      :class="{ 'border-b pb-5 mb-5': filterToggle }">
      <div class="font-bold">
        <span>Equipe {{ object.id }} </span>
      </div>
      <div class="flex gap-5">
        <span v-if="object.points >= object.daily_meta && object.daily_meta > 0" class="bg-green-400 mx-1"
          >Meta Pontos Atingida</span
        >
        <span v-if="object.daily_meta == 0" class="bg-yellow-400 mx-1">Meta Pontos Não Definida</span>
        <span v-if="object.points < object.daily_meta && object.daily_meta > 0" class="bg-red-500 mx-1"
          >Meta Pontos não Atingida
        </span>
        <i
          class="fa-solid fa-chevron-down transition"
          :class="{ 'rotated-icon': filterToggle }"
          @click="toggleFilter"></i>
      </div>
    </div>
    <TheTransition>
      <div v-if="filterToggle">
        <div>
          <div class="w-full flex">
            <div class="w-[40%] border-2 rounded-xl mr-2">
              <div class="flex justify-between px-2">
                <h1 class="font-bold text-sm flex items-center">Custos Operacionais</h1>
                <div v-for="(item, index) in items" :key="index" class="rounded-xl py-5">
                  <span class="text-sm flex flex-col mb-2">{{ item.text }}</span>
                  <b class="ml-1">{{ formatMoneyS(object[item.field]) }}</b>
                </div>
              </div>
            </div>
            <div class="w-[60%] flex gap-2 text-white">
              <TheKPICard
                v-for="(card, index) in cards"
                :key="index"
                :color="card.class"
                :value="object[card.total] ?? 0"
                :title="card.title"
                class="w-[33%]"
                :tooltipText="card.tooltipText"
                tamanhoH1="text-md"
                :money="card.money" />
            </div>
          </div>
        </div>
      </div>
    </TheTransition>
  </Card>
</template>

<script>
import { get } from '@/crud.js'
import { useFormat } from '@/composables/useFormat'

const { formatMoneyS } = useFormat()

export default {
  props: {
    object: {
      type: Object,
      required: true,
    },
    date: {
      type: Object,
    },
    check: false,
  },

  data: () => ({
    filterToggle: false,

    pages: null,
    page: 0,
    actualPage: 1,
    limit: 20,
    selectedTeam: null,
    filterProtocol: false,
    showModal: false,
    points: null,
    items: [],
    itemsProtocol: [],
    headers: [
      { title: 'Protocolo', field: 'protocolo' },
      { title: 'Serviço', field: 'idServiceRequested', align: 'text-center' },
      { title: 'Equipe', field: 'idTeam', align: 'text-center' },
      { title: 'Data', field: 'performedDate' },
    ],
    cards: [
      {
        class: 'bg-card-blueLight',
        title: 'Valor medido',
        total: 'medicaoTotal',
        money: true,
      },
      {
        class: 'bg-card-blueMedium',
        title: 'Custo Total',
        total: 'totalValue',
        money: true,
      },
      {
        class: 'bg-card-blueDark',
        title: 'Meta Mensal',
        total: 'dailyMeta',
        money: true,
      },
      {
        class: 'bg-card-purpleLight',
        title: 'Total de pontos',
        total: 'points',
        money: false,
      },
    ],
    items: [
      {
        text: 'Mão Obra: ',
        field: 'encargos',
      },
      {
        text: 'Veículos: ',
        field: 'chargeValue',
      },

      {
        text: 'Combs: ',
        field: 'fuelValue',
      },
      {
        text: 'Base: ',
        field: 'baseValue',
      },
    ],
  }),

  methods: {
    formatMoneyS,
    async searchItems(page = 1, idTeam) {
      const query = {
        params: {
          page: page,
          limit: this.limit,
          filters: [{ column: 'idTeam', value: idTeam }],
        },
      }

      if (typeof this.date === 'string') {
        query.params.filters.push({ column: 'startDate', value: this.date })
        query.params.filters.push({ column: 'endDate', value: this.date })
      } else {
        query.params.filters.push({ column: 'startDate', value: this.date[0] })
        query.params.filters.push({ column: 'endDate', value: this.date[1] })
      }

      const raw = await get(`osMedicao`, query)
      this.itemsProtocol = raw.data
      this.pages = Math.ceil(raw.total / this.limit)
    },

    selectTeam(idTeam) {
      this.selectedTeam = idTeam
      this.searchItems(1, idTeam)
    },

    toggleFilter() {
      this.filterToggle = !this.filterToggle
    },

    toggleProtocol() {
      this.filterProtocol = !this.filterProtocol
    },
  },

  watch: {
    check() {
      this.filterToggle = this.check
    },
    checkP() {
      this.filterProtocol = this.checkP
    },
    actualPage() {
      this.searchItems(this.actualPage, this.object.idTeam)
    },
  },
}
</script>
<style>
.rotated-icon {
  transform: rotate(-180deg);
  transition: transform 0.3s ease ease-out;
}
.transition {
  transition: transform 0.3s ease-out;
}
</style>
